import { useState, useContext, useEffect, useRef } from "react"
import { BtnLoader, CSelect, toast, CInputText, CInputPassword, CToggle, CModal, MapCont, CInputTextArea } from "../../components/widget"
import { ContextNav, ContextDashboard, ContextLoading } from "../../context";
import { AddLocationApi } from "../../api";
import { useNavigate, Link } from "react-router-dom";

export const LocationAdd = () => {
    const navigate = useNavigate()
    const formRef: any = useRef()
    const CtxNav = useContext(ContextNav)
    const CtxLoad = useContext(ContextLoading)
    const [position, setPosition] = useState<any>(null);


    const onFinishAdd = async (e: any) => {
        e.preventDefault()
        if (position == null) { toast("لطفا مکان خود را برروی نقشه انتخاب نمایید", { type: "error" }) }
        CtxLoad.setDisplayLoadingBtn(true)
        let res = await AddLocationApi(formRef, position)
        CtxLoad.setDisplayLoadingBtn(false)
        if (res.success) {
            toast("موقعیت مکانی جدید ایجاد گردید", { type: "success" })
            navigate('/p/location');
        }
        else {
            toast(res.message, { type: "error" })
        }
    }



    useEffect(() => {
        document.title = "اضافه کردن موقعیت مکانی | دایان"
        CtxNav.setActiveMenuItem({ 'item': 5, 'subItem': 0, })
    }, [])

    return (
        <div className=" w-full flex flex-col">
            <h1 className="sm:text-2xl text-lg font-bold mb-[30px]">اضافه کردن موقعیت مکانی جدید</h1>

            <form ref={formRef} onSubmit={onFinishAdd} className=" w-full  flex flex-col shadow sm:rounded-xl rounded-lg bg-white py-[15px] sm:py-[30px] sm:px-[20px] px-[10px]">


                <div className=" w-full flex flex-col md:flex-row items-center mt-[15px] sm:mt-[40px] border-b pb-[15px] sm:pb-[30px]">
                    <div className=" w-full   flex flex-col sm:flex-row items-center">
                        <div className=" w-full sm:w-[50%] h-[50px] flex sm:mt-0 mt-5 items-center pl-0 sm:pl-2 relative">
                            <div className=" w-full h-full pl-1">
                                <CInputText name="name" title="نام موقعیت مکانی" type="text" required={true} />
                            </div>
                        </div>
                    </div>
                </div>

                <div className=" w-full flex flex-col md:flex-row items-center mt-[15px] sm:mt-[40px] border-b pb-[15px] sm:pb-[30px]">
                    <div className=" w-full   flex flex-col sm:flex-row items-center">
                        <div className=" w-full sm:w-[50%]  flex sm:mt-0 mt-5 items-center pl-0 sm:pl-2 relative">
                            <div className=" w-full h-full pl-1">
                                <CInputTextArea name="description" title="توضیحات" custom_class="min-h-[100px]" />
                            </div>
                        </div>
                    </div>
                </div>

                <div className=" w-full flex flex-col md:flex-row items-center mt-[15px] sm:mt-[40px] border-b pb-[15px] sm:pb-[30px]">
                    <div className=" w-full   flex flex-col sm:flex-row items-center">
                        <div className=" w-full sm:w-[50%] h-[50px] flex sm:mt-0 mt-5 items-center pl-0 sm:pl-2 relative">
                            <div className=" w-full h-full pl-1">
                                {/* <CInputText name="distance" title="شعاع" type="number" required={true} /> */}
                                <CSelect  name="distance" placeholder="شعاع" title="شعاع" required={true} border={true}>
                                    <option value={5}>5</option>
                                    <option value={10}>10</option>
                                    <option value={20}>20</option>
                                    <option value={40}>40</option>
                                    <option value={60}>60</option>
                                    <option value={80}>80</option>
                                    <option value={100}>100</option>
                                </CSelect>
                            </div>
                        </div>
                    </div>
                </div>

                <div className=" w-full flex flex-col md:flex-row items-center mt-[15px] sm:mt-[40px] border-b pb-[15px] sm:pb-[30px]">
                    <div className=" w-full  flex flex-col  ">
                        <span className="text-[11px]">موقعیت مکانی بر روی نقشه</span>
                        <div className=" w-full h-[300px] border mt-4 rounded-lg overflow-hidden">
                            <MapCont position={position} setPosition={setPosition} />
                        </div>
                    </div>
                </div>


                <div className=" w-full mt-[40px] flex items-center">
                    {CtxLoad.displayLoadingBtn ?
                        <button type="button" className="w-[100px] h-[40px] bg-dayan-gray-200 text-white rounded-[5px] text-sm shadow cursor-not-allowed relative flex justify-center items-center"><BtnLoader /></button>
                        :
                        <button type="submit" className="w-[100px] h-[40px] bg-dayan-gray-200 text-white rounded-[5px] text-sm shadow">اعمال</button>
                    }
                    <Link to='/p/location'>
                        <button type="button" className="w-[100px] h-[40px] bg-[#a4a4a4] text-dayan-gray-200 rounded-[5px] mr-3 text-sm shadow">بازگشت</button>
                    </Link>
                </div>

            </form>



        </div>
    )
}
